import { isValidEmail } from '../../../lib/utils.js';

export const validateEmployee = (values) => {
  const errors = {};
  if (!values.firstName) {
    errors.firstName = 'First name is required';
  }

  if (!values.lastName) {
    errors.lastName = 'Last name is required';
  }

  if (!values.email) {
    errors.email = 'Email is required';
  }

  if (!isValidEmail(values.email)) {
    errors.email = 'Invalid email format.';
  }
  return errors;
};
